var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Devolução de exemplar","titleIcon":"fas fa-undo-alt"}},[_c('devolucao')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }